import { CHAIN_USDC_ADDRESSES, CHAIN_WETH_ADDRESSES } from "../../tokens.js";
import { DEAD_ADDRESS, VITALIK } from "../../integration.js";
import { CORE_PINNED_BLOCK_HASHES, CORE_PINNED_BLOCK_HEIGHTS, CORE_PINNED_TRANSACTION_HASHES } from "../pinned.js";
import { AAVE_V3_COLLECTOR, ERC20_BALANCE_OF_REFERENCE_CALLDATA, SWAP_QUOTE_AMOUNT, } from "../fixture-inputs.js";
export const BASE_TEST_CONFIG = {
    balance: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.base,
    },
    tokenBalance: {
        address: VITALIK,
        token: CHAIN_USDC_ADDRESSES.base,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.base,
    },
    blockQuery: {
        block: CORE_PINNED_BLOCK_HEIGHTS.base,
        fixture: "getBlockByNumberBase",
    },
    balanceQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.base,
        fixture: "getBalanceBase",
    },
    tokenBalanceQuery: {
        address: VITALIK,
        token: CHAIN_USDC_ADDRESSES.base,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.base,
        fixture: "getTokenBalanceBase",
    },
    blockHashQuery: {
        hash: CORE_PINNED_BLOCK_HASHES.base,
        fixture: "getBlockByHashBase",
    },
    blockTransactionsQuery: {
        blockNumber: CORE_PINNED_BLOCK_HEIGHTS.base,
        fixture: "getBlockTransactionsBase",
    },
    transfersQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.base,
        fixture: "getTransfersBase",
    },
    simulateCallQuery: {
        to: CHAIN_USDC_ADDRESSES.base,
        data: ERC20_BALANCE_OF_REFERENCE_CALLDATA,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.base,
        fixture: "simulateCallBase",
    },
    traceTransactionQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.base,
        fixture: "traceTransactionBase",
    },
    tokenMetadataQuery: {
        address: CHAIN_USDC_ADDRESSES.base,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.base,
        fixture: "getTokenMetadataBase",
    },
    tokenAllowanceQuery: {
        token: CHAIN_USDC_ADDRESSES.base,
        owner: VITALIK,
        spender: DEAD_ADDRESS,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.base,
        fixture: "getTokenAllowanceBase",
    },
    portfolioQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.base,
    },
    receiptQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.base,
        fixture: "getReceiptBase",
    },
    transactionByHashQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.base,
        fixture: "getTransactionByHashBase",
    },
    estimateGasQuery: {
        to: VITALIK,
        fixture: "estimateGasBase",
    },
    aaveV3Query: { address: AAVE_V3_COLLECTOR.base, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.base, fixture: "getAaveV3UserPositionsBase" },
    compoundV3Query: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.base, fixture: "getCompoundV3UserPositionsBase" },
    lidoQuery: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.base, fixture: "getLidoUserPositionsBase" },
    morphoQuery: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.base, fixture: "getMorphoUserPositionsBase" },
    approvalsQuery: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.base, fixture: "getApprovalsBase" },
    pendleV2InfoQuery: { fixture: "getPendleV2InfoBase" },
    curvePoolsQuery: { blockHeight: CORE_PINNED_BLOCK_HEIGHTS.base, fixture: "getCurvePoolsBase" },
    uniswapV3QuoteQuery: { tokenIn: CHAIN_WETH_ADDRESSES.base, tokenOut: CHAIN_USDC_ADDRESSES.base, amount: SWAP_QUOTE_AMOUNT, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.base, fixture: "getUniswapV3QuoteBase" },
    uniswapV4QuoteQuery: { tokenIn: CHAIN_WETH_ADDRESSES.base, tokenOut: CHAIN_USDC_ADDRESSES.base, amount: SWAP_QUOTE_AMOUNT, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.base, fixture: "getUniswapV4QuoteBase" },
    avantisPriceQuery: { vault: "avUSDC", blockHeight: CORE_PINNED_BLOCK_HEIGHTS.base, fixture: "getAvantisPriceBase" },
    approvalsRevokeQuery: { address: VITALIK, token: CHAIN_USDC_ADDRESSES.base, spender: CHAIN_WETH_ADDRESSES.base, fixture: "getApprovalsRevokeBase" },
};
